import { DealernetApi } from "./DealernetApi";

export const LIFTLINK_CONTROLLER_PATH = "/LiftLink";

export class LiftLinkService {

  // Do not call this function from various areas of the site. All feature flags are loaded during site authentication
  // Rather, use getFeatureEnabled() to check by feature name from const.js
  public static async GetLiftLinkConfiguration(){
    const response = await DealernetApi.client().get(
      `${LIFTLINK_CONTROLLER_PATH}/GetConfiguration`
    );
    return response.data;
  } 
}
